import { I as t } from "../../constants-DeVuDy8J.js";
import { createElementBlock as r, openBlock as d, normalizeClass as s, createElementVNode as n } from "vue";
import { _ as l } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const o = {
  name: "DtIconBriefcase",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (a) => Object.keys(t).includes(a)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], _ = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M3.94 1.44A1.5 1.5 0 0 1 5 1h2a1.5 1.5 0 0 1 1.5 1.5V3H10a1.5 1.5 0 0 1 1.5 1.5v5A1.5 1.5 0 0 1 10 11H2A1.5 1.5 0 0 1 .5 9.5v-5A1.5 1.5 0 0 1 2 3h1.5v-.5c0-.398.158-.78.44-1.06ZM3.5 4H2a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h1.5V4Zm1 6V4h3v6h-3Zm4 0H10a.5.5 0 0 0 .5-.5v-5A.5.5 0 0 0 10 4H8.5v6Zm-1-7h-3v-.5A.5.5 0 0 1 5 2h2a.5.5 0 0 1 .5.5V3Z",
  "clip-rule": "evenodd"
}, null, -1), m = [
  _
];
function h(a, f, i, u, v, e) {
  return d(), r("svg", {
    "aria-label": i.ariaLabel,
    class: s([e.iconSizeClass, "d-icon d-icon--briefcase"]),
    "data-qa": e.dataQA,
    "aria-hidden": e.ariaHidden,
    role: "img",
    "data-name": "Briefcase",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, m, 10, c);
}
const g = /* @__PURE__ */ l(o, [["render", h]]);
export {
  g as default
};
//# sourceMappingURL=briefcase.js.map
